<template>
  <section
    class="home"
  >
    <slide-y-up-transition appear>
      <FilterHeader class="home--sliderfilters" />
    </slide-y-up-transition>
    <slide-y-down-transition
      :delay="50"
      appear
    >
      <LowerThird
        class="home--lowerthird"
        :title="filterTitle"
      />
    </slide-y-down-transition>
    <ProductFilter
      v-if="!$isMobile"
      class="home--filters desktop"
      @toProducts="scrollToProducts(true)"
    />

    <div>
      <ProductList
        ref="productlist"
        class="home--productlist"
        :filter-type="$store.state.filters.filterType"
        :filter-value="$store.state.filters.filterValue"
      />
      <transition
        name="fade"
        appear
      >
        <router-view ref="popin" />
      </transition>
      <ProductFilter
        v-if="$isMobile"
        class="home--filters mobile"
      />
      <BackToTop class="home--backtotop" />
      <TeaserBanner v-if="$currentWave < $config.common.maxWave" />
      <PushList />
    </div>
  </section>
</template>

<script>
import LowerThird from '@/components/common/lowerthird/LowerThird.vue';
import ProductList from '@/components/layouts/products/ProductList.vue';
import ProductFilter from '@/components/layouts/products/ProductFilter.vue';
import FilterHeader from '@/components/layouts/products/FilterHeader.vue';
import BackToTop from '@/components/common/buttons/BackToTop.vue';
import TeaserBanner from '@/components/layouts/teaser/TeaserBanner.vue';
// mixins
import filterMixin from '@/components/common/filter/FilterMixin.vue';
import PushList from '@/components/layouts/push/PushList.vue';

export default {
  name: 'Home',
  components: {
    LowerThird,
    ProductList,
    ProductFilter,
    FilterHeader,
    BackToTop,
    TeaserBanner,
    PushList,
  },

  mixins: [filterMixin],

  data() {
    return {
    };
  },

  computed: {
    autoScroll() {
      return true;
    },
    filterTitle() {
      return this.currentFilter ? this.processPluralString(this.currentFilter.shortlabel, this.currentFilter.count) : '';
    },
  },

  watch: {
    filterType() {
      this.scrollToProducts();
    },
    filterValue() {
      this.scrollToProducts();
    },
  },

  methods: {
    isBelowFold() {
      return window.scrollY > this.$refs.productlist.$el.offsetTop || (this.$attributes.forceAutoScroll || false);
    },
    scrollToProducts(forced = false) {
      if (this.autoScroll && (this.isBelowFold() || forced)) this.$refs.productlist.$el.scrollIntoView({ block: 'start' });
    },
  },
};
</script>
<style lang="stylus" scoped>
.home {
  padding-top: 10px;
  +mobile() {
    padding-top: 0;
  }
  &--lowerthird {
    margin: -108px auto 20px;

    +mobile() {
      margin: -21px auto 0;
    }
  }
  &--productlist {
    padding-top: 20px;
    scroll-margin-top: 40px;
  }
  &--filters.desktop {
    position: sticky;
    top: 0;
    z-index: 90;
    +mobile(){
      display: none;
    }
  }

  &--filters.mobile {
    position: sticky;
    bottom: 0;
    z-index: 90;
    +desktop(){
      display: none;
    }
  }

  &--sliderfilters {
    margin: 0 auto;
  }

  &--backtotop {
    margin: 50px auto 20px;
    +mobile() {
      margin-top: 20px auto 20px;
    }
  }
}
</style>
